module.exports = __webpack_public_path__ + "static/media/chess2.c83a52b8.png";